const UNIQUE = {
  mid: function () {
    function s4 () {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
    }
    const mmid = `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`
    return mmid
  },
  fileid: function () {
    const fileid = (new Date().valueOf())
    return fileid
  }
}

export default UNIQUE
